<template>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <DataTable :headers="headers" :path="path" actionButtonsName="ContractsListActionButtons" :properties="properties">
    </DataTable>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {
  props: {
    personal: Object
  },

  components: {
    DataTable
  },

  computed: {
    path () {
      return `contracts/player/${this.personal.pk}/${this.personal.club.pk}`
    },
    loading () {
      return !this.personal.hasOwnProperty('pk')
    },
    headers () {
      const headers = [
        { text: 'Tipo', value: 'contract_type', align: 'left' },
        { text: 'Contrato', value: 'status' },
        { text: 'Fecha de inicio', value: 'start_date' },
        { text: 'Fecha de fin', value: 'end_date' },
        { text: 'Adendas', value: 'addenda' },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(0, 0, { text: 'ID', value: 'id' })
      }

      return headers
    },
    properties () {
      const props = ['contractType', 'statusDisplay', 'startDate', 'endDate', 'addenda']

      if (this.$store.getters.isSafRole) {
        props.splice(0, 0, 'id')
      }

      return props
    }
  }
}
</script>
